import { TextBadge } from '@carvana/ds-badge';
import { useContext, useMemo } from 'react';
import { activeTradeStatuses, TradeStatus } from '@/common/TradeCard/constants';
import TradeContext from '~/context/common/TradeContext';
import useGetTradeInStatus from '~/hooks/common/selectors/useGetTradeStatus';

type OwnProps = {
  isHighNetTrade?: boolean;
};

export default function StatusBadge({ isHighNetTrade }: OwnProps) {
  const { selectedTrade } = useContext(TradeContext);
  const tradeStatus = useGetTradeInStatus();
  const { daysToExpiration = null } = selectedTrade ?? {};
  const daysToExpired = daysToExpiration ?? 0;
  const showStatus =
    Boolean(activeTradeStatuses[tradeStatus] && daysToExpiration != null) ||
    !Boolean(activeTradeStatuses[tradeStatus]);

  const statusText = useMemo(() => {
    switch (true) {
      case isHighNetTrade:
        return 'Not applied';
      case Boolean(activeTradeStatuses[tradeStatus]):
        return daysToExpired === 0
          ? 'Expires today'
          : `Expires in ${daysToExpired} day${daysToExpired > 1 ? 's' : ''}`;
      default:
        return `${tradeStatus}`;
    }
  }, [daysToExpired, isHighNetTrade, tradeStatus]);

  const priority = useMemo(() => {
    if (isHighNetTrade) return 'informational';

    switch (tradeStatus) {
      case TradeStatus.Active:
        return 'success';
      case TradeStatus.ExpiringSoon:
        return 'warning';
      case TradeStatus.Expired:
        return 'critical';
      default:
        return 'informational';
    }
  }, [isHighNetTrade, tradeStatus]);

  return showStatus ? (
    <TextBadge
      variant={tradeStatus === TradeStatus.Expired ? 'strong' : 'outline'}
      priority={priority}
      data-testid="trade-status-badge"
    >
      {statusText}
    </TextBadge>
  ) : null;
}
